var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMyTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2941 12.7059C14.2941 12.4135 14.5312 12.1765 14.8235 12.1765H20.4706C20.763 12.1765 21 12.4135 21 12.7059C21 12.9983 20.763 13.2353 20.4706 13.2353H14.8235C14.5312 13.2353 14.2941 12.9983 14.2941 12.7059Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2941 16.2353C14.2941 15.943 14.5312 15.7059 14.8235 15.7059H20.4706C20.763 15.7059 21 15.943 21 16.2353C21 16.5277 20.763 16.7648 20.4706 16.7648H14.8235C14.5312 16.7648 14.2941 16.5277 14.2941 16.2353Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2941 19.7648C14.2941 19.4724 14.5312 19.2354 14.8235 19.2354H20.4706C20.763 19.2354 21 19.4724 21 19.7648C21 20.0571 20.763 20.2942 20.4706 20.2942H14.8235C14.5312 20.2942 14.2941 20.0571 14.2941 19.7648Z",
    fill: "inherit"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2353 6.1765C16.1378 6.1765 16.0588 6.25551 16.0588 6.35297C16.0588 6.64536 15.8218 6.88238 15.5294 6.88238L14.8235 6.88238C14.7261 6.88238 14.647 6.96139 14.647 7.05885V8.47062C14.647 8.56808 14.7261 8.64709 14.8235 8.64709H20.4706C20.568 8.64709 20.6471 8.56808 20.6471 8.47062V7.05885C20.6471 6.96139 20.568 6.88238 20.4706 6.88238H19.7647C19.4723 6.88238 19.2353 6.64536 19.2353 6.35297C19.2353 6.25551 19.1563 6.1765 19.0588 6.1765H16.2353ZM15.1188 5.82356C15.3171 5.40621 15.7425 5.11768 16.2353 5.11768H19.0588C19.5516 5.11768 19.977 5.40621 20.1752 5.82356H20.4706C21.1528 5.82356 21.7059 6.37662 21.7059 7.05885V8.47062C21.7059 9.15285 21.1528 9.70591 20.4706 9.70591H14.8235C14.1413 9.70591 13.5882 9.15285 13.5882 8.47062V7.05885C13.5882 6.37662 14.1413 5.82356 14.8235 5.82356L15.1188 5.82356Z",
    fill: "inherit"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4118 8.29418C12.9244 8.29418 12.5294 8.68922 12.5294 9.17653V21.8824C12.5294 22.3697 12.9244 22.7648 13.4118 22.7648H21.8823C22.3697 22.7648 22.7647 22.3697 22.7647 21.8824V9.17653C22.7647 8.68922 22.3697 8.29418 21.8823 8.29418H21.1765V7.23535H21.8823C22.9544 7.23535 23.8235 8.10445 23.8235 9.17653V21.8824C23.8235 22.9545 22.9544 23.8236 21.8823 23.8236H13.4118C12.3397 23.8236 11.4706 22.9545 11.4706 21.8824V9.17653C11.4706 8.10445 12.3397 7.23535 13.4118 7.23535H13.7647V8.29418H13.4118Z",
    fill: "inherit"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35293 1.23534C4.30623 1.23534 2.64705 2.89452 2.64705 4.94122C2.64705 6.98792 4.30623 8.6471 6.35293 8.6471C8.39963 8.6471 10.0588 6.98792 10.0588 4.94122C10.0588 2.89452 8.39963 1.23534 6.35293 1.23534ZM1.58823 4.94122C1.58823 2.30975 3.72146 0.176514 6.35293 0.176514C8.98441 0.176514 11.1176 2.30975 11.1176 4.94122C11.1176 7.57269 8.98441 9.70592 6.35293 9.70592C3.72146 9.70592 1.58823 7.57269 1.58823 4.94122Z",
    fill: "inherit"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35295 11.8235C3.50824 11.8235 1.23531 14.0424 1.23531 16.7394V23.9999H0.176483V16.7394C0.176483 13.4217 2.9601 10.7646 6.35295 10.7646C7.808 10.7646 9.14858 11.252 10.2061 12.0695L9.55859 12.9072C8.68261 12.2301 7.56881 11.8235 6.35295 11.8235Z",
    fill: "inherit"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTasks);
export default __webpack_public_path__ + "static/media/MyTasks.e17f68974578bcd1f4273f1fe86a3824.svg";
export { ForwardRef as ReactComponent };